import {
    PortfolioSummaryDataAction,
    PortfolioSummaryDataActionType,
} from './actions';
import {
    initialPortfolioSummaryDataState,
    PortfolioSummaryDataState,
} from './PortfolioSummaryDataState';
import uniq from 'lodash/uniq';
import { PortfolioSummaryConfigAction } from '../instances/configuration/actions';
import {
    isSetOrLoadConfigActionFor,
    WidgetActionType,
} from 'widgets/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import { Reducer } from 'redux';

export const portfolioSummaryDataReducer: Reducer<
    PortfolioSummaryDataState,
    PortfolioSummaryDataAction | PortfolioSummaryConfigAction
> = (state = initialPortfolioSummaryDataState, action) => {
    switch (action.type) {
        case WidgetActionType.WIDGET_LOAD_CONFIG:
        case WidgetActionType.WIDGET_SET_CONFIG: {
            if (
                !isSetOrLoadConfigActionFor(
                    WidgetType.PORTFOLIO_SUMMARY,
                    action
                )
            ) {
                return state;
            }
            return {
                ...state,
                streamingAggregationFields: uniq([
                    ...state.streamingAggregationFields,
                    action.payload!.configDelta.aggregationField!,
                ]),
            };
        }
        case PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_SET_AGGREGATED_DATA: {
            return {
                ...state,
                aggregatedData: {
                    ...state.aggregatedData,
                    [action.payload!.aggregationField]: action.payload!.data,
                },
            };
        }
        case PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_DATA_CLEAR_AGGREGATED_DATA: {
            const next = { ...state };
            delete next.aggregatedData[action.payload!.aggregationField];
            return next;
        }
        case PortfolioSummaryDataActionType.PORTFOLIO_SUMMARY_SET_DRILLDOWN_DATA: {
            const aggregatedData =
                state.aggregatedData[action.payload!.aggregationField];
            if (!aggregatedData) {
                return state;
            }

            const next = { ...state };

            aggregatedData[action.payload!.drillDown.groupName] =
                aggregatedData[action.payload!.drillDown.groupName] || {};
            const group = aggregatedData[action.payload!.drillDown.groupName];

            group.drillDowns = group.drillDowns || {};
            group.drillDowns[action.payload!.drillDown.aggregationField] =
                action.payload!.aggregatedData;

            return next;
        }
    }
    return state;
};
